import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.watercraft.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.watercraft.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.watercraft.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.watercraft.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.watercraft.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    watercraft: {
        id: 'ml.policychange.watercraft.Watercraft',
        defaultMessage: 'Watercraft'
    },
    addWatercraft: {
        id: 'ml.policychange.watercraft.Add a watercraft',
        defaultMessage: 'Add a watercraft'
    },
    editWatercraft: {
        id: 'ml.policychange.watercraft.Edit a watercraft',
        defaultMessage: 'Edit a watercraft'
    },
    underlyingPolicyNotListed: {
        id: 'ml.policychange.watercraft.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    addAPolicy: {
        id: 'ml.policychange.watercraft.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    cancel: {
        id: 'ml.policychange.watercraft.cancel',
        defaultMessage: 'Cancel'
    },
    addWatercraftDynamic: {
        id: 'ml.policychange.watercraft.Add Watercraft',
        defaultMessage: 'Add Watercraft'
    },
    editWatercraftDynamic: {
        id: 'ml.policychange.watercraft.Edit Watercraft',
        defaultMessage: 'Edit Watercraft'
    },
    
});
